import { render, staticRenderFns } from "./ConsentLetterModal.vue?vue&type=template&id=035a8da2&scoped=true"
import script from "./ConsentLetterModal.vue?vue&type=script&lang=js"
export * from "./ConsentLetterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035a8da2",
  null
  
)

export default component.exports